import * as React from "react";

function BoxCheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M208.1 392.1c-8.5 10.2-23.7 10.2-33.1 0l-56-56c-9.3-8.5-9.3-23.7 0-33.1 9.4-9.3 24.6-9.3 33.1 0l39.9 39.1 95-95.1c9.4-9.3 24.6-9.3 33.1 0 10.2 9.4 10.2 24.6 0 33.1l-112 112zm234.4-228.5c3.6 8.2 5.5 17 5.5 26V416c0 35.3-28.7 64-64 64H64c-35.35 0-64-28.7-64-64V189.6c0-9 1.879-17.8 5.516-26L47.11 70.01C57.38 46.89 80.3 32 105.6 32h236.8c25.3 0 48.2 14.9 58.5 38.01l41.6 93.59zM248 160h140.4L357 89.5c-2.5-5.78-8.3-9.5-14.6-9.5H248v80zM48 416c0 8.8 7.16 16 16 16h320c8.8 0 16-7.2 16-16V208H48v208zM200 80h-94.4c-6.33 0-12.06 3.72-14.63 9.5L59.64 160H200V80z"
  }));
}

const ForwardRef = React.forwardRef(BoxCheckIcon);
export default ForwardRef;